import React from "react"
import NewsletterForm from "./Form"
import "./index.css"

const NewsLetter = () => {
  return (
    <section id="newsletter-section">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center newsletter-head-text">
            <h1>WinterGarten Variete Newsletter</h1>
            <h2>Lorem Ipsum is simply dummy text of the printing</h2>
            <NewsletterForm />
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewsLetter
